var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelchairJoysticks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.92,40.81h-9.79l-2.73-12.96c2.69-1.61,4.49-4.55,4.49-7.9,0-5.08-4.14-9.22-9.22-9.22s-9.22,4.14-9.22,9.22c0,3.36,1.81,6.29,4.49,7.9l-2.73,12.96H14.56c-2.6,0-4.72,2.12-4.72,4.72v9.83c0,.83,.67,1.5,1.5,1.5H52.14c.83,0,1.5-.67,1.5-1.5v-9.83c0-2.6-2.12-4.72-4.72-4.72ZM31.68,13.72c3.43,0,6.22,2.79,6.22,6.22s-2.79,6.22-6.22,6.22-6.22-2.79-6.22-6.22,2.79-6.22,6.22-6.22Zm1.94,15.44l2.45,11.64h-8.78l2.45-11.64h3.88Zm17.03,24.7H12.84v-8.33c0-.95,.77-1.72,1.72-1.72H48.92c.95,0,1.72,.77,1.72,1.72v8.33Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairJoysticks);
export default __webpack_public_path__ + "static/media/wheelchair_joysticks.645da617.svg";
export { ForwardRef as ReactComponent };